export default __webpack_public_path__ + "static/media/wrongIcon.d1472c59.svg";